export const appConfig = {
  apiUrl: process.env.REACT_APP_BACKEND_API,
  graphqlUrl: process.env.REACT_APP_BACKEND_API_GRAPHQL
};
